import PropTypes from 'prop-types';

import PaymentError from '../../Payment/PaymentError';
import { Modal } from '@zillow/constellation-10';

const propTypes = {
  errorMessage: PropTypes.string,
  isInMaintenanceMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const defaultProps = {
  errorMessage: null,
  isInMaintenanceMode: undefined,
};

const PaymentErrorModal = ({ errorMessage, isInMaintenanceMode, onClose }) => (
  <Modal
    open={true}
    onOpenChange={(open) => !open && onClose()}
    size={{ base: 'fullScreen', md: 'md' }}
    body={
      <div data-testid="PaymentErrorModal">
        <PaymentError errorMessage={errorMessage} isInMaintenanceMode={isInMaintenanceMode} />
      </div>
    }
  />
);

PaymentErrorModal.propTypes = propTypes;
PaymentErrorModal.defaultProps = defaultProps;

export default PaymentErrorModal;
